import { Button, Menu, rgba, Text } from "@mantine/core"
import { IconChevronDown } from "@tabler/icons-react"
import { LanguageIso6391 } from "@tfg/types/schemas/enum"
import React from "react"

import { useGetTranslationsContext } from "../context/translationsContext/useGetTranslationsContext"

type Props = {
  style?: React.CSSProperties
  languages?: LanguageIso6391[]
  onLanguageChange: (lang: string) => void
  getLanguageName: (lang: LanguageIso6391) => string
}

export function LangSwitcher({
  style,
  languages,
  onLanguageChange,
  getLanguageName,
}: Props) {
  const { currentLanguage } = useGetTranslationsContext()

  const otherAvailableLanguages = (languages || []).filter(
    (lang) => lang.toLowerCase() !== currentLanguage
  )

  if (otherAvailableLanguages.length === 0) {
    return null
  }

  return (
    <div style={style}>
      <Menu>
        <Menu.Target>
          <Button
            rightSection={
              <IconChevronDown width={12} height={12} color="#000" />
            }
            style={{ backgroundColor: "transparent" }}
          >
            <Text size="md" style={{ color: "#000" }}>
              {getLanguageName(
                currentLanguage.toUpperCase() as LanguageIso6391
              )}
            </Text>
          </Button>
        </Menu.Target>
        <Menu.Dropdown style={{ backgroundColor: rgba("#FFF", 0.5) }}>
          {otherAvailableLanguages.map((key) =>
            key.toLowerCase() !== currentLanguage ? (
              <Menu.Item
                key={key}
                onClick={() => onLanguageChange(key.toLowerCase())}
                rightSection={
                  <IconChevronDown
                    width={12}
                    height={12}
                    style={{ visibility: "hidden" }}
                  />
                }
                style={{ backgroundColor: "transparent" }}
              >
                <Text size="md" style={{ color: "#000" }}>
                  {getLanguageName(key.toUpperCase() as LanguageIso6391)}
                </Text>
              </Menu.Item>
            ) : null
          )}
        </Menu.Dropdown>
      </Menu>
    </div>
  )
}
